module.exports = __webpack_public_path__ + "static/media/p3.3ebedf3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/personalization/images/urbanhipster/p3.jpg
// module id = 2937
// module chunks = 0